module.exports = __webpack_public_path__ + "media/packs/components/weployer/jobs/templates/job-repost-placeholder-0e3ca61d621cad610abbcd98fdc890b3.png";